module.exports = "<p>\n  user-edit works!\n</p>\n"